import {
  Box,
  Divider,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';

import { useAuth } from '../../../hooks/auth';

import { ButtonGroup } from './styles';

type SortData = {
  por: string;
  cres: boolean;
};
type ControlsData = {
	page: number;
	perPage: number;
	totalPage: number;
};
type ClassificacaoData = {
	id: number;
	id_sub: number;
	nome: string;
	prod_visible: boolean;
	status: string;
}
type ProdutoData = {
  id: string;
  categoria: string;
  cod_barras: string;
  complementos: string;
  descricao: string;
  nome: string;
  promocao: string;
  qtd: number;
  status: string;
  url_imagem: string;
  id_classif: number;
	valor: number;
	total: number;
	valorFormatted: string;
	totalFormatted: string;
};
interface DataTableTableParams {
  produtos: ProdutoData[];
  pesqProdutos: ProdutoData[];
  sort: SortData;
  setSort: (sort: SortData) => void;
  controls: ControlsData;
  handleUpdateList: (page: number, perPage: number, produtos: ProdutoData[]) => void;
	setClassifModal: (classif: ClassificacaoData) => void;
	setProdutoModal: (product: ProdutoData) => void;
	setModalPausarAtivarVisible: (visible: boolean) => void;
	setModalProdutoVisible: (visible: boolean) => void;
	handleFindClassif: (classif: string) => void;
}

const DataTableTable: React.FC<DataTableTableParams> = ({
  produtos,
  pesqProdutos,
  sort,
  setSort,
  controls,
  handleUpdateList,
	setClassifModal,
	setProdutoModal,
	setModalPausarAtivarVisible,
	setModalProdutoVisible,
	handleFindClassif,
}) => {
	const { permissions } = useAuth();
	
  function handleSort(prop: string) {
    let mapped: ProdutoData[] = [];

    const auxCres = !sort.cres;

    if (sort.por === prop) {
      if (auxCres) {
        mapped = pesqProdutos.sort((a, b) => {
          return (
            +(Object(a)[prop] > Object(b)[prop]) ||
            +(Object(a)[prop] === Object(b)[prop]) - 1
          );
        });
      } else {
        mapped = pesqProdutos.sort((a, b) => {
          return (
            +(Object(a)[prop] < Object(b)[prop]) ||
            +(Object(a)[prop] === Object(b)[prop]) - 1
          );
        });
      }
      setSort({ ...sort, cres: auxCres });
    } else {
      mapped = pesqProdutos.sort((a, b) => {
        return (
          +(Object(a)[prop] > Object(b)[prop]) ||
          +(Object(a)[prop] === Object(b)[prop]) - 1
        );
      });
      setSort({ por: prop, cres: true });
    }

    // setSort({ por: prop, cres: !sort.cres });

    handleUpdateList(1, controls.perPage, mapped);
  }

  return (
    <Table colorScheme="blackAlpha">
      <Thead>
        <Tr>
          <Th cursor="pointer" onClick={() => handleSort('nome')}>
            <Flex align="center">
              Nome
              {sort.por === 'nome' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'nome' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

					<Th cursor="pointer" onClick={() => handleSort('valor')}>
						<Flex justifyContent="flex-end">
              Valor
              {sort.por === 'valor' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'valor' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

					<Th cursor="pointer" onClick={() => handleSort('total')}>
						<Flex justifyContent="flex-end">
              Total
              {sort.por === 'total' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'total' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>
					
					{permissions.alterar && (
						<Th cursor="pointer">
							<Flex justifyContent="flex-end">
								Ativar/desativar
							</Flex>
						</Th>
					)}

					{(permissions.incluir || permissions.alterar) && (
						<Th></Th>
					)}
        </Tr>
      </Thead>

      <Tbody>
        {produtos.map(produto => {
          return (
						<Tr key={produto.id} fontSize={14} fontWeight={500}>
              <Td py="2" cursor="pointer">
                <Box>
                  <Text color="blue.500">
                    {produto.nome}
                  </Text>
									<Text fontSize="sm" color="gray.500">
										{produto.categoria} - {produto.cod_barras}
                  </Text>
                </Box>
              </Td>

              <Td isNumeric py="2" color="gray.500">
                {produto.valorFormatted}
              </Td>

							<Td isNumeric py="2" color="gray.500">
                {produto.totalFormatted}
              </Td>

							{permissions.alterar && (
								<Td isNumeric>
									<ButtonGroup status={produto.status === 'S' ? true : false}>
										<button
											className="btn-desativar"
											onClick={() => {
												setClassifModal({} as ClassificacaoData);
												setProdutoModal(produto);
												setModalPausarAtivarVisible(true);
											}}
											disabled={produto.status === 'N'}
										>
											{produto.status === 'N' ? 'Pausado' : 'Pausar'}
										</button>
										<button
											className="btn-ativar"
											onClick={() => {
												setClassifModal({} as ClassificacaoData);
												setProdutoModal(produto);
												setModalPausarAtivarVisible(true);
											}}
											disabled={produto.status === 'S'}
										>
											{produto.status === 'S' ? 'Ativo' : 'Ativar'}
										</button>
									</ButtonGroup>
								</Td>
							)}

							{(permissions.alterar || permissions.excluir) && (
								<Td>
									<Menu>
										{({ isOpen }) => (
											<>
												<MenuButton
													border={0}
													fontSize="1.5626rem"
													as={IconButton}
													isActive={isOpen}
													aria-label="Options"
													icon={<FiMoreVertical />}
													variant="outline"
													_hover={{
														bg: 'gray.50'
													}}
												/>

												<MenuList p={0} boxShadow='xl'>
													{permissions.alterar && (
														<MenuItem
															fontSize={16}
															fontWeight={500}
															py={3}
															_hover={{ bg: 'gray.50' }}
															onClick={() => {
																handleFindClassif(produto.categoria);
																// setClassifModal(classif);
																setProdutoModal(produto);
																setModalProdutoVisible(true);
															}}
														>
															Editar
														</MenuItem>
													)}

													{permissions.excluir && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																isDisabled={true}
															>
																Excluir
															</MenuItem>
														</>
													)}

													{permissions.incluir && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																isDisabled={true}
															>
																Duplicar
															</MenuItem>
														</>
													)}
												</MenuList>
											</>
										)}
									</Menu>
								</Td>
							)}
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
};

export default DataTableTable;
